import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type NotificationType = "success" | "info" | "warning" | "error";

/**
 * `GH₵${amount}.00` (naive string concat) was the previous pattern on the
 * Transactions page — breaks for any amount that already has decimals
 * (e.g. 150.5 → "GH₵150.5.00") and renders "GH₵undefined.00" before the
 * doctor record has loaded.
 */
export function formatCurrency(amount: number | null | undefined): string {
  const value = typeof amount === "number" && !Number.isNaN(amount) ? amount : 0;
  return `GH₵${value.toFixed(2)}`;
}

export function isDateWithinHourLimit(submittedDate: Date): boolean {
  const currentDateTime = new Date();
  const oneHourInMillis = 60 * 60 * 1000; // 1 hour in milliseconds

  // Calculate the difference between current time and submitted time
  const timeDifference = currentDateTime.getTime() - submittedDate.getTime();

  // Check if the time difference is within the limit (1 hour)
  const isWithinHourLimit = timeDifference <= oneHourInMillis;

  return isWithinHourLimit;
}

export const firebaseSignupErrorMessage = (error : any): string => {
 let errorMessage = "An error occurred during sign-up, try again.";
    switch (error.code) {
    case "auth/email-already-in-use":
        errorMessage = "The email address is already in use.";
        break;
    case "auth/invalid-email":
        errorMessage = "Invalid email address. Please check the format.";
        break;
    case "auth/weak-password":
        errorMessage =
        "The password is too weak. Please choose a stronger one.";
        break;
    case "auth/network-request-failed":
        errorMessage =
        "Network request failed. Check your internet connection.";
        break;
    //TODO
    // Add more cases for other error codes as needed
    }
    return errorMessage;
}

export const firebaseSigninErrorMessage = (error : any): string => {
 let errorMessage = "An error occurred during sign-in, try again.";
    switch (error.code) {
    case "auth/user-not-found":
        errorMessage = "Account not found. Kindly register!";
        break;
    case "auth/wrong-password":
        errorMessage = "Invalid credentials. Please try again!";
        break;
    case "auth/network-request-failed":
        errorMessage =
        "Network request failed. Check your internet connection.";
        break;
    case "ERR_NETWORK":
        errorMessage =
        "Network request failed. Please try again!";
        break;
    //TODO
    // Add more cases for other error codes as needed
    }
    return errorMessage;
}

export function checkAppointmentStatus(date: string, startTime: string, endTime: string): string {
  const [day, month, year] = date.split("-").map(Number);
  const [startHour, startMinute] = startTime.slice(0, -2).split(":").map(Number);
  const [endHour, endMinute] = endTime.slice(0, -2).split(":").map(Number);
  const isStartPM = startTime.slice(-2).toLowerCase() === "pm";
  const isEndPM = endTime.slice(-2).toLowerCase() === "pm";
  let adjustedStartHour = startHour;
  let adjustedEndHour = endHour;

  if (isStartPM && startHour !== 12) {
    adjustedStartHour += 12;
  } else if (!isStartPM && startHour === 12) {
    adjustedStartHour = 0;
  }

  if (isEndPM && endHour !== 12) {
    adjustedEndHour += 12;
  } else if (!isEndPM && endHour === 12) {
    adjustedEndHour = 0;
  }
  
  const appointmentDateTime = new Date(year, month - 1, day, adjustedStartHour, startMinute);
  const endDateTime = new Date(year, month - 1, day, adjustedEndHour, endMinute);
  const currentDateTime = new Date();
  
  if (currentDateTime.getTime() > endDateTime.getTime()) {
    return "passed";
  } else if (currentDateTime.getTime() > appointmentDateTime.getTime() && currentDateTime.getTime() < endDateTime.getTime()) {
    return "within-time";
  } else {
    return "waiting";
  }
}


export function schedulePassed(date: string, startTime: string, endTime?: string): boolean {
  const [day, month, year] = date.split("-").map(Number);
    const [startHour, startMinute] = startTime.slice(0, -2).split(":").map(Number);
  //   const [endHour, endMinute] = endTime.slice(0, -2).split(":").map(Number);
    const isStartPM = startTime.slice(-2).toLowerCase() === "pm";
  //   const isEndPM = endTime.slice(-2).toLowerCase() === "pm";
    let adjustedStartHour = startHour;
  //   let adjustedEndHour = endHour;

    if (isStartPM && startHour !== 12) {
      adjustedStartHour += 12;
    } else if (!isStartPM && startHour === 12) {
      adjustedStartHour = 0;
    }

  //   if (isEndPM && endHour !== 12) {
  //     adjustedEndHour += 12;
  //   } else if (!isEndPM && endHour === 12) {
  //     adjustedEndHour = 0;
  //   }
    
    const appointmentDateTime = new Date(year, month - 1, day, adjustedStartHour, startMinute);
  //   const endDateTime = new Date(year, month - 1, day, adjustedEndHour, endMinute);
    const currentDateTime = new Date();
      if (currentDateTime.getTime() > appointmentDateTime.getTime()) {
          return true
      }
      return false
}